import { render, staticRenderFns } from "./AISetupDrawer.vue?vue&type=template&id=46bed82e"
import script from "./AISetupDrawer.vue?vue&type=script&lang=js"
export * from "./AISetupDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports